<template>
  <div class="cp-ShoppingList_Overlay">
    <input v-if="isActive" type="hidden" name="variants[][id]" :value="variant" />
    <input v-if="isActive" type="hidden" name="variants[][quantity]" :value="currentAmount" />

    <button
      v-if="isActive"
      type="button"
      class="btn btn-outline-success cp-ShoppingList_Button"
      @click="decreaseAmount"
    >
      <i class="fa fa-minus"></i>
    </button>
    <div
      v-if="currentAmount > 0 || amount > 0"
      class="h6 mb-0 cp-ShoppingList_Amount p-1"
      :class="{ 'cp-ShoppingList_Amount-active': isActive }"
    >
      {{ currentAmount }}
      <span v-if="amount > 0">
        {{ ` / ${amount}` }}
      </span>
    </div>
    <button
      type="button"
      class="btn btn-outline-success cp-ShoppingList_Button"
      :disabled="currentAmount >= purchaseLimit"
      @click="checkboxClickHandler"
    >
      <i class="fa fa-plus"></i>
    </button>
  </div>
</template>

<script>
import ShoppingListStore from "./ShoppingListStore";

export default {
  name: "StoreShoppingList_Item",
  props: {
    variant: {
      required: true,
      type: String,
    },
    amount: {
      type: Number,
      default: 0,
    },
    preselected: {
      type: Boolean,
      default: false,
    },
    purchaseLimit: {
      type: Number,
      default: 50,
    },
  },
  data() {
    return {
      sharedState: ShoppingListStore.state,
      currentAmount: this.preselected ? this.amount : 0,
    };
  },
  computed: {
    isActive() {
      return this.currentAmount > 0;
    },
    isInitial() {
      return this.currentAmount == this.amount;
    },
  },
  mounted() {
    this.preselected && ShoppingListStore.increase(this.amount);
  },
  methods: {
    increaseAmount() {
      if (this.currentAmount < this.purchaseLimit) {
        this.currentAmount++;
        ShoppingListStore.increase();
      }
    },
    decreaseAmount() {
      if (this.currentAmount > 0) {
        this.currentAmount--;
        ShoppingListStore.decrease();
      }
    },
    setInitial() {
      const value = this.amount > 0 ? this.amount : 1;
      this.currentAmount = value;
      ShoppingListStore.increase(value);
    },
    checkboxClickHandler() {
      if (this.isActive) {
        this.increaseAmount();
      } else {
        this.setInitial();
      }
    },
  },
};
</script>
